import Loader from "@/features/shared/components/Loader";

const globalLoader = new Loader();
export default globalLoader;